export enum Command {
    Sync = 'Sync',
    SyncDeleted = 'SyncDeleted',
}
